




















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({})
export default class Intro extends Vue {
  @Prop() courseDetail: any
  async created() {
  }
  goBuy() {
    if (this.$route.query.spuId) return window.location.href = `${window.location.origin}/goods/goodsView?spuId=${this.$route.query.spuId}`
    return window.location.href = `${window.location.origin}/knowlege/channelDetail?id=${this.courseDetail.id}`
  }
}
